

export const BedroomsState = {
    show: false,
    options: [
        {label: 'مهم نیست', value: 0, checked: false},
        {label: 'حداقل 1 خوابه', value: 1, checked: false},
        {label: 'حداقل 2 خوابه', value: 2, checked: false},
        {label: 'حداقل 3 خوابه', value: 3, checked: false},
        {label: 'حداقل 4 خوابه', value: 4, checked: false},
        {label: 'حداقل 5 خوابه', value: 5, checked: false}
    ],
    selected_items: [],
};


